// Packages
import { v4 as uuidv4 } from "uuid";

// Img
import { ReactComponent as WirelessSignal0 } from "assets/images/icons/icn_table_cell_wifi_signal_0.svg";
import { ReactComponent as WirelessSignal2 } from "assets/images/icons/icn_table_cell_wifi_signal_2.svg";
import { ReactComponent as WirelessSignal3 } from "assets/images/icons/icn_table_cell_wifi_signal_3.svg";
import { ReactComponent as WiredSignal } from "assets/images/icons/icn_table_cell_wired.svg";

export const uuids = {
  main: uuidv4(),
  actionSelector: {
    blockClient: () => uuidv4(),
  },
};

export const defaultTabs = [
  {
    name: "All",
    value: "all",
    disabled: null,
    icon: null,
    isActive: true,
    tabCount: 0
  },
  {
    name: "Wired",
    value: "wired",
    disabled: null,
    icon: null,
    isActive: false,
    tabCount: 0
  },
  {
    name: "Wireless",
    value: "wireless",
    disabled: null,
    icon: null,
    isActive: false,
    tabCount: 0
  },
]

export const linkStatusTagDefinition = {
  red: ["offline"],
  green: ["online"],
  grey: ["onboarding"],
  redDark: ["critical"],
  orange: ["warning"],
  blue: ["info"],
};

export const linkStatusLabelDefinition = {
  offline: "Offline",
  online: "Online",
  onboarding: "Onboarding",
  critical: "Critical",
  warning: "Warning",
  info: "Info",
};

export const customGroupDefinition = [
  {
    groupNames: ["Status"],
    columns: {
      "Status": [
        "status", "clientName", "manufacturer",
        "ipAddress", "clientId",
        "authenticationType", "connectedToDeviceName", "interface",
        "vlan", "ssid",
        "channel", "formattedLastSeen", "formattedSignal",
      ],
    }
  },
  {
    groupNames: ["Statistic"],
    columns: {
      "Statistic": [
        "snr", "formattedDownload", "formattedUpload", "formattedTraffic", "formattedUpTime",
      ],
    }
  },
]

export const rssiDefinition = {
  wireless: {
    poor: {
      value: "poor",
      icon: WirelessSignal0
    },
    good: {
      value: "good",
      icon: WirelessSignal2
    },
    excellent: {
      value: "excellent",
      icon: WirelessSignal3
    },
  },
  wired: {
    value: null,
    icon: WiredSignal
  }
}

export const redirectionDeviceTypeDefinition = {
  switch: "switches",
  ap: "accessPoints",
}